export default __webpack_public_path__ + "static/media/crs-min.7eadfb0d.webp";